import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { tokens } from "@/art/tokens";

/**
 * 모바일 세로(portrait) 감지 오버레이.
 *
 * 게임 디자인이 1920×1080 고정이라, 좁은 세로 화면에서는 StageCanvas 가 얇은 띠로
 * 축소돼 블랭크처럼 보인다. 이 오버레이가 풀 스크린으로 덮고, 가로 모드로 돌리면
 * 자연스럽게 사라진다. 태블릿/데스크톱 가로에서는 나타나지 않음.
 *
 * 기준: viewport.innerWidth < 900 AND height > width (portrait).
 */
export function OrientationGuard() {
    const [portrait, setPortrait] = useState(false);

    useEffect(() => {
        const check = () => {
            const w = window.innerWidth;
            const h = window.innerHeight;
            // 900px 이하의 좁은 장비에서만 portrait 경고. 데스크톱은 세로 비율이어도 무시.
            setPortrait(w < 900 && h > w);
        };
        check();
        window.addEventListener("resize", check);
        window.addEventListener("orientationchange", check);
        return () => {
            window.removeEventListener("resize", check);
            window.removeEventListener("orientationchange", check);
        };
    }, []);

    return (
        <AnimatePresence>
            {portrait && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 flex items-center justify-center"
                    style={{
                        background: tokens.color.ink,
                        zIndex: 9999,
                    }}
                >
                    <div className="text-center px-l">
                        <motion.div
                            animate={{ rotate: [0, 90, 90, 0, 0] }}
                            transition={{ duration: 3, repeat: Number.POSITIVE_INFINITY, ease: "easeInOut" }}
                            className="mx-auto mb-l"
                            style={{ width: 80, height: 120 }}
                        >
                            <svg viewBox="0 0 80 120" width="80" height="120">
                                <rect
                                    x="6" y="6" width="68" height="108" rx="10"
                                    fill="none"
                                    stroke={tokens.color.ember}
                                    strokeWidth={3}
                                />
                                <circle cx="40" cy="102" r="3" fill={tokens.color.ember} />
                            </svg>
                        </motion.div>
                        <div
                            className="font-display mb-m"
                            style={{
                                color: tokens.color.ember,
                                fontSize: tokens.type.size.subtitle,
                                letterSpacing: tokens.type.letterSpacing.wide,
                            }}
                        >
                            가로 모드로 돌려주세요
                        </div>
                        <p
                            className="font-body"
                            style={{
                                color: tokens.color.parchmentDim,
                                fontSize: tokens.type.size.small,
                                lineHeight: tokens.type.lineHeight.normal,
                            }}
                        >
                            이 이야기는 가로 방향의 무대로 설계되었습니다.
                            <br />
                            기기를 돌리면 바로 이어집니다.
                        </p>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
